import { render, staticRenderFns } from "./ParcelGalleryMore.vue?vue&type=template&id=afd76414&scoped=true&"
import script from "./ParcelGalleryMore.vue?vue&type=script&lang=js&"
export * from "./ParcelGalleryMore.vue?vue&type=script&lang=js&"
import style0 from "./ParcelGalleryMore.vue?vue&type=style&index=0&id=afd76414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd76414",
  null
  
)

export default component.exports